import { ObterDadosFormaPagamentoResposta } from "app/api/classes/OrcamentoApi"
import { useAppSelector } from "app/redux/hooks"
import { IOrcamento } from "app/types/IOrcamento"
import React, { useEffect, useRef, useState } from "react"
import microuniversoApi from 'app/api/microuniversoApi'
import { alterarFormaPagamento } from "app/use-cases/orcamento/alterarFormaPagamento"
import { atualizarRecalcularParcelas as atualizarRecalcularParcelasUseCase} from "app/use-cases/orcamento/atualizarRecalcularParcelas"
import { Parametro, ParametroPorItem } from "app/types/Parametro"
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import { PromiseQueue } from "PromiseQueue"
import { excluirParcelas as excluirParcelasUseCase } from '../../use-cases/orcamento/excluirParcelas'
import { atualizarParcelasFormaPagamentoNoEstadoOrcamento } from "app/use-cases/orcamento/atualizarParcelasFormaPagamentoNoEstadoOrcamento"
import * as R from 'ramda'
import { AbaFormaDePagamento, ParcelaFormaDePagamento } from "./aba-forma-de-pagamento/AbaFormaDePagamento"
import { removerFormaPagamento as removerFormaPagamentoUseCase } from 'app/use-cases/orcamento/removerFormaPagamento'
import { igualarParcelasPrazo as igualarParcelasAPrazoUseCase } from 'app/use-cases/orcamento/igualarParcelasPrazo'
import { recalcularPrecos as recalcularPrecosUseCase } from 'app/use-cases/orcamento/recalcularPrecos'
import { DadosParcela } from "../../types/IncluirEditarParcela";
import { tratamentoErroPadrao } from "app/use-cases"
import { de } from "date-fns/locale"

export type FormaDePagamentoContainerProps = {
    somenteLeitura?: boolean,
    executarAcaoLimpar?: boolean
    onEditarParcela: (parcela: DadosParcela) => void
    onIncluirParcela: () => void
}

export const FormaDePagamentoContainer = (props: FormaDePagamentoContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    
    const carregando = useRef(true)
    const chamandoAtualizarDadosFormaPagamentoPeloUseEffect = useRef(false)

    const isMounted = useRef(true)
    const [processando, setProcessando] = useState<boolean>(false)
    
    const [dadosFormaPagamento, setDadosFormaPagamento] = useState<ObterDadosFormaPagamentoResposta>(null)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([])  // 414608


    const [promiseQueue] = useState(new PromiseQueue())

    const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor
    const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find(p => p.Nome == nome)?.Valor // 414608

    const atualizarParametros = async () => {
        if (!isMounted.current) return
        const params = await obterParametros({
            nomes: [
                "EMPRESA_UTILIZA_PLANO_DE_PAGAMENTO",
                "VENDA_RECEBER_ENTREGA"
            ]
        })

        const paramsPorItem = await obterParametrosPorOidItem({  // 414608
            nomes: [
                "TRABALHA_COBRANCA_PIX_PRAZO",
            ],
            oidItem: orcamento.OidFilialOrcamento ?? 0
        })
        if (isMounted.current) {
            setParametros(params)
            carregando.current = false
            setParametrosPorFilial(paramsPorItem)  // 414608
        }
    }

    const atualizarFormaPagamentoOuTipoDocumento = async (codigoFormaPagamento: number, codigoTipoDocumento: number) => {
    try {
        setProcessando(true)
        if (!isMounted.current) return
        globalMU.blockScreen()//477121  
        globalMU.blockUI()

        const resposta = await alterarFormaPagamento({
            codigoFormaPagamento,
            codigoTipoDocumento: codigoTipoDocumento
        });
        globalMU.blockScreen()//477121 
        globalMU.blockUI() 

        if(resposta && isMounted.current){
            globalMU.blockScreen()//477121 
            globalMU.blockUI() 
            setDadosFormaPagamento(resposta)
            globalMU.blockScreen()//477121
            globalMU.blockUI()  
            await recalcularPrecosUseCase(orcamento.RecalcularPrecos)
            globalMU.blockScreen()//477121
            globalMU.blockUI()  
        }
    } catch (e) {
        tratamentoErroPadrao(e)
    } finally {
        globalMU.blockScreen()//477121
        setTimeout(() => {
            // espera um pouco para evitar desbloqueio na tela
        setProcessando(false)
            globalMU.unblockScreen() //477121
            globalMU.unblockUI()
        }, 400);
        
    }
}

    const atualizarDadosFormaPagamento = async () => {
        
        if (!isMounted.current) return
        if (!orcamento || orcamento.ValorTotal == undefined) return
    try {
        if (!chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current){
            globalMU.blockUI()  
            globalMU.blockScreen()//477121       
        }

       // setProcessando(true)
        const dadosFormaPagamentoAtualizados = await microuniversoApi.Orcamento.obterDadosFormaPagamento({
            identificadorOrcamento: orcamento.IdentificadorOrcamento,
            codigoFormaPagamento: orcamento.CodigoFormaPagamento,
            codigoTipoDocumento: orcamento.CodigoTipoDocumento,
            valorOrcamento: orcamento.ValorTotal,
            verificarPendenciaFormaDePagamento: orcamento.VerificarPendenciaFormaDePagamento,
            removerItensOuValoresModificados: chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current // para informar q o usuario ha viu  as parcelas alteradas
        })
 

        if (isMounted.current) {

            let oidTipoDocumento = dadosFormaPagamentoAtualizados.CodigoTipoDocumento
// && 481325 - melhorar performance if (dadosFormaPagamentoAtualizados != null && dadosFormaPagamentoAtualizados.TiposDocumento?.length == 1) {
//     oidTipoDocumento = dadosFormaPagamentoAtualizados.TiposDocumento[0].Codigo
    
//  }
            if (!isMounted.current) return
            setDadosFormaPagamento({...dadosFormaPagamentoAtualizados, CodigoTipoDocumento: oidTipoDocumento})
            /*
            if (!R.equals(orcamento.ParcelasFormaPagamento, dadosFormaPagamentoAtualizados.Parcelas)) {
                if (!isMounted.current) return
                atualizarParcelasFormaPagamentoNoEstadoOrcamento(dadosFormaPagamentoAtualizados.Parcelas)
            }
            */
            let atualizar = !R.equals(orcamento.ParcelasFormaPagamento, dadosFormaPagamentoAtualizados.Parcelas)
            atualizar = atualizar || orcamento.ElegivelParaEmailCobrancaPixPrazo != dadosFormaPagamentoAtualizados.ElegivelParaEmailCobrancaPixPrazo
            if (atualizar) {
                if (!isMounted.current) return
                atualizarParcelasFormaPagamentoNoEstadoOrcamento(dadosFormaPagamentoAtualizados.Parcelas, dadosFormaPagamentoAtualizados.ElegivelParaEmailCobrancaPixPrazo)
            }
            if (dadosFormaPagamentoAtualizados != null && dadosFormaPagamentoAtualizados.TiposDocumento?.length == 1) {
                if (!isMounted.current) return
                atualizarFormaPagamentoOuTipoDocumento(orcamento.CodigoFormaPagamento, dadosFormaPagamentoAtualizados.TiposDocumento[0].Codigo)
            }
        }
    } catch (e) {
        tratamentoErroPadrao(e)
    } finally {
         if (!chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current){
            globalMU.unblockUI()  
            globalMU.unblockScreen() //477121      
    }
    }
    }
    

    const atualizarRecalcularParcelas = async (recalcular: boolean)=>  {
        if (!isMounted.current) return
        await atualizarRecalcularParcelasUseCase({
            identificadorOrcamento: orcamento.IdentificadorOrcamento,
            recalcular
        })
    }

    const excluirParcelas = async (codigosParcelas: number[]) => {
        if (!isMounted.current) return
        await excluirParcelasUseCase(codigosParcelas)

        promiseQueue.enqueue(atualizarDadosFormaPagamento)
    }

    const incluirParcela = () => {
        if (!isMounted.current) return
        props.onIncluirParcela()
    }

    const editarParcela = (codigo: number) => {
        if (!isMounted.current) return
        const parcela = (orcamento.ParcelasFormaPagamento ?? []).find(p => p.Codigo == codigo)

        props.onEditarParcela(parcela)
    }

    const algumaParcelaPossuiMaisDeUmaParcelaNoCartao = () => {
        return (orcamento?.ParcelasFormaPagamento ?? []).some(parcela => parcela.QuantidadeParcelasCartao > 1)
    }

    const mostrarAjudaRecalcularParcelas = () => {
        globalMU.showInfoMessage("Quando campo \"Recalcular Parcelas\" estiver DESMARCADO:<br><ul><li>- A alteração do valor de uma parcela para cima ou para baixo não irá alterar o valor das demais parcelas.</li></ul><p><br>" +
            "Quando campo \"Recalcular Parcelas\" estiver MARCADO:<br><ul><li>- Ao alterar o valor da ENTRADA tanto para cima quanto para baixo, o valor das demais parcelas será igualado, considerando a alteração do valor da entrada.</li><br>" +
            "<li>- Apenas a última parcela é passível de alteração, para um valor MENOR.</li><br><li>- Ao alterar o valor da última parcela para um valor menor, será criada nova parcela com o valor deduzido da última parcela.</li></ul>")
    }

    const mostrarAjudaRecalcularPrecos = () => {
        globalMU.showInfoMessage("Quando campo \"Recalcular Preços\" estiver DESMARCADO:<br><ul>" +
            "<li>- Não será recalculado o valor do preço do produto ao trocar forma de pagamento de maneira automática.</li></ul><p><br>" +
            "Quando campo \"Recalcular Preços\" estiver MARCADO:<br><ul>" +
            "<li>- Será recalculado o valor do preço do produto ao trocar forma de pagamento de maneira automática.</li><br>" +
            "<li>- Ao iniciar o orçamento, se o parâmetro \"Recalcular os valores do pedido automaticamente quando a condição de pagamento for alterada\" estiver ativado, o \"Recalcular Preços\" virá marcado.</li><br>"
        )
    }

    const removerFormaPagamento = async () => {
        await removerFormaPagamentoUseCase()
    }

    const igualarParcelasAPrazo = async () => {
        await igualarParcelasAPrazoUseCase()
        
        promiseQueue.enqueue(atualizarDadosFormaPagamento)  // 423226
    }

    const recalcularPrecosModificado = async (recalcular: boolean) => {
        await recalcularPrecosUseCase(recalcular)
    }

    const receberNaEntrega = async (parcela_: ParcelaFormaDePagamento) => {
        try {
            globalMU.blockUI()

            const recebimentoNaEntregaValido = await microuniversoApi.Orcamento.validarReceberEntrega(orcamento.IdentificadorOrcamento)

            if (!recebimentoNaEntregaValido && isMounted.current) {
                const parcelaAlterada = { ...parcela_, RecebimentoNaEntrega: false } as ParcelaFormaDePagamento
                const novasParcelas = R.update(dadosFormaPagamento.Parcelas.indexOf(dadosFormaPagamento.Parcelas.find(i => i.Codigo == parcela_.Codigo)), parcelaAlterada, dadosFormaPagamento.Parcelas)

                setDadosFormaPagamento({ ...dadosFormaPagamento, Parcelas: novasParcelas })
                return
            }

            if (isMounted.current) {
                const novasParcelas = R.update(dadosFormaPagamento.Parcelas.indexOf(dadosFormaPagamento.Parcelas.find(i => i.Codigo == parcela_.Codigo)), parcela_, dadosFormaPagamento.Parcelas)
                setDadosFormaPagamento({ ...dadosFormaPagamento, Parcelas: novasParcelas })

                var ret = await microuniversoApi.Orcamento.atualizarParcela(orcamento.IdentificadorOrcamento, [parcela_])
                atualizarParcelasFormaPagamentoNoEstadoOrcamento(novasParcelas)
               
            }

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            
            globalMU.unblockUI()
        }
    }

    const onMarcarDesmarcarTodosReceberNaEntrega = async (codigosParcelasSelecionadas: number[]) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI()

            const recebimentoNaEntregaValido = await microuniversoApi.Orcamento.validarReceberEntrega(orcamento.IdentificadorOrcamento)

            if (recebimentoNaEntregaValido && isMounted.current) {
                const parcelas = dadosFormaPagamento.Parcelas.filter(i => codigosParcelasSelecionadas.includes(i.Codigo))
                const parcelasAlterada = parcelas.map(p => ({ ...p, RecebimentoNaEntrega: true }));

                const novaListaCompleta = parcelas.map((p) => parcelasAlterada.find((novaParcela) => novaParcela.Codigo === p.Codigo) ?? p);
                setDadosFormaPagamento({ ...dadosFormaPagamento, Parcelas: novaListaCompleta })

                await microuniversoApi.Orcamento.atualizarParcela(orcamento.IdentificadorOrcamento, parcelasAlterada)
            }

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    useEffect(() => {
        if (!isMounted.current) return
        if (chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current)
            return
        setProcessando(true)
        globalMU.blockScreen()//477121
        chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current = true

        promiseQueue
            .enqueue(atualizarDadosFormaPagamento)
            .finally(() => {

                setTimeout(() => {
                    
                    // espera um pouco para evitar desbloqueio na tela
                    setProcessando(false)
                    globalMU.unblockScreen() //477121
                    globalMU.unblockUI()
                    chamandoAtualizarDadosFormaPagamentoPeloUseEffect.current = false
                    
                }, 400);
            })

    }, [
        orcamento.CodigoFormaPagamento,
        orcamento.CodigoTipoDocumento,
        orcamento.ValorTotal,
        orcamento.VerificarPendenciaFormaDePagamento
    ])

    useEffect(() => {
        carregando.current = true
        setProcessando(true)
        globalMU.blockScreen()//477121
        atualizarParametros()
		return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        if (!carregando.current && props.executarAcaoLimpar === true) {
            removerFormaPagamento()
        }
    }, [props.executarAcaoLimpar])

    return (
<>
{isMounted.current && parametros && parametros.length > 0 
        && dadosFormaPagamento != null && dadosFormaPagamento.FormasPagamento != null && dadosFormaPagamento.FormasPagamento.length > 0
    ?
    <>
        <AbaFormaDePagamento
            onReceberNaEntrega={receberNaEntrega}
            parametrosPorFilial={parametrosPorFilial} // 414608 
            formasDePagamento={dadosFormaPagamento?.FormasPagamento ?? []}
            tiposDeDocumento={dadosFormaPagamento?.TiposDocumento ?? []}
            corSelecionada={""}
            onMostrarAjudaRecalcularParcelas={mostrarAjudaRecalcularParcelas}
            onEditarParcela={editarParcela}
            onExcluirParcelas={excluirParcelas}
            onFormaDePagamentoModificada={codigoFormaPagamento => atualizarFormaPagamentoOuTipoDocumento(codigoFormaPagamento, null)}
            onIgualarParcelasPrazo={igualarParcelasAPrazo}
            onIncluirParcela={incluirParcela}
            onTipoDeDocumentoModificado={codigoTipoDocumento => atualizarFormaPagamentoOuTipoDocumento(orcamento.CodigoFormaPagamento, codigoTipoDocumento)}
            parcelas={dadosFormaPagamento?.Parcelas ?? []}
            orcamento={orcamento}
            existePendenciaPrazoMedioEntrega={dadosFormaPagamento?.PendenciaPrazoMedioEntrega ?? false}
            onRecalcularParcelasModificado={atualizarRecalcularParcelas}
            exibirColunaReceberNaEntrega={valorParametro("VENDA_RECEBER_ENTREGA") === "S"}
            possuiCartaoParcelado={algumaParcelaPossuiMaisDeUmaParcelaNoCartao()}
            onMostrarAjudaRecalcularPrecos={mostrarAjudaRecalcularPrecos}
            onRecalcularPrecosModificado={recalcularPrecosModificado}
            onMarcarDesmarcarTodosReceberNaEntrega={onMarcarDesmarcarTodosReceberNaEntrega}
            processando={processando}

        />


    </>
    : null
    }
 </>
    )
}


